import React, { ReactNode } from 'react'
import styles from './styles/forms.module.scss'
import classNames from 'classnames'

interface Props {
  classWrapper?: string
  classLabel?: string
  classStaticText?: string
  label: ReactNode
  formikName: string
  fieldAsStaticText?: boolean
  valueStaticText?: string | number
  children?: ReactNode
}

const FormInputGroup = ({
  children,
  formikName,
  label,
  classWrapper = '',
  classLabel = '',
  classStaticText = '',
  fieldAsStaticText = false,
  valueStaticText = '',
}: Props) => {
  if (fieldAsStaticText)
    return (
      <div className={classWrapper}>
        <p className={classNames(styles.formLabel, styles.staticTextLabel, classLabel)}>{label}</p>
        <p className={classNames(styles.staticText, classStaticText)}>{valueStaticText}</p>
      </div>
    )

  return (
    <div className={classWrapper}>
      {typeof label === 'string' ? (
        <label
          className={classNames(styles.formLabel, classLabel)}
          htmlFor={formikName}
          data-formik-error={formikName}
        >
          {label}
        </label>
      ) : (
        label
      )}
      {children}
    </div>
  )
}

export default FormInputGroup
